export default function initVisionCarousel(Swiper, Navigation, Autoplay) {
    // ==========================================================
    // VISION CARDS
    // ==========================================================
    const visionSliders = document.querySelectorAll(".vision-grid__slider");

    visionSliders.forEach((slider) => {
        let swiper = null;

        const prevButton = slider.querySelector(".vision-grid__arrow--prev");

        const nextButton = slider.querySelector(".vision-grid__arrow--next");

        const initSlider = () => {
            const useCarousel = window.innerWidth < 1300;

            // ==================================================
            // CAROUSEL < 1300PX
            // ==================================================

            if (useCarousel && !swiper) {
                swiper = new Swiper(slider, {
                    modules: [Navigation, Autoplay],
                    loop: true,
                    watchOverflow: true,
                    autoplay: {
                        delay: 2500,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    },
                    slidesPerView: 1.15,
                    spaceBetween: 16,

                    navigation: {
                        prevEl: prevButton,
                        nextEl: nextButton,
                    },

                    breakpoints: {
                        640: {
                            slidesPerView: 1.5,
                            spaceBetween: 20,
                        },

                        768: {
                            slidesPerView: 2.2,
                            spaceBetween: 24,
                        },

                        1024: {
                            slidesPerView: 3.2,
                            spaceBetween: 24,
                        },
                    },
                });

                return;
            }

            // ==================================================
            // GRILLE >= 1300PX
            // ==================================================

            if (!useCarousel && swiper) {
                swiper.destroy(true, true);

                swiper = null;
            }
        };

        initSlider();

        window.addEventListener("resize", initSlider);
    });
}
